import React from 'react'

import theme from 'theme'

export const Divider: React.FC = (props) => (
  <div
    css={{
      flex: 1,
      height: 1,
      backgroundColor: theme.colors.border[0]
    }}
    {...props}
  />
)

export const VerticalDivider: React.FC = (props) => (
  <div
    css={{
      flex: 1,
      width: 1,
      backgroundColor: theme.colors.border[0]
    }}
    {...props}
  />
)

export default Divider
